module.exports = __webpack_public_path__ + "static/media/protagonist.78f6b1c0.obj";